import { Pagination } from 'antd'
import React from 'react'

const PaginationPage = ({data,setPage}) => {
    
  const onChange = (pageNumber) => {
    setPage(pageNumber)
  };
  return (
    <div className='my-4'>        
      <Pagination 
        defaultCurrent={data?.data?.pageNumber} 
        total={data?.data?.totalCount}
        // showSizeChanger
        defaultPageSize={15}
        onChange={onChange}
      />
    </div>
  )
}

export default PaginationPage